const modal = document.getElementById('dialog-video-player-vimeo');
const closeModal = document.getElementById('close-vimeo-video-player');
const modalTrigger = document.getElementById('vimeo-video-trigger');
const vimeoContainer = document.getElementById('vimeo-video-container');

let player = null;

modalTrigger.addEventListener("click", () => {

    vimeoContainer.innerHTML = '';

    player = new Vimeo.Player(vimeoContainer, {
        id: 1233454335,
        width: 640,
        autoplay: true,
        muted: true,
        loop: false
    });

    player.ready().then(() => {
        modal.showModal();
        body.classList.add("no-scroll");
    }).then(() => {
        return player.setCurrentTime(39);
    }).then(() => {
        return player.setMuted(false);
    }).then(() => {
        console.log('Video successfully unmuted via user interaction chain.');
    }).catch((error) => {
        console.warn('Browser blocked unmuted autoplay. Video remains muted.', error);
    });

});

closeModal.addEventListener("click", () => {
    if (player) {
        player.destroy();
        player = null;
    }
    modal.close();
    body.classList.remove("no-scroll");
});